import { Icons } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { refetchFunc } from 'modules/domain/common/hooks'
import * as managers from 'modules/domain/common/managers'
import { DocumentWithTypeFile } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { AUploadFileButton } from 'views/components/UploadFileButton/AUploadFileButton'
import { SampleRequestDocsType } from 'views/pages/Samples/types'

type Props = {
  sampleRequestId: string
  refetchDocs: refetchFunc
  docType: SampleRequestDocsType
}

export const AddSampleRequestDocs: FC<Props> = ({ sampleRequestId, refetchDocs, docType }) => {
  const { t } = useTranslation('common')

  const [progress, addHandler] = useAProgress<DocumentWithTypeFile[]>(
    (files: File[]) => {
      const promises: Promise<DocumentWithTypeFile>[] = []
      for (const file of files) {
        promises.push(managers.uploadDocuments(endpoints.sampleRequestDocuments(sampleRequestId), docType, file))
      }
      return Promise.all(promises)
    },
    {
      eventName: 'addSampleRequestFiles',
      onSuccess: () => refetchDocs(),
    },
  )
  return (
    <AUploadFileButton
      eventName="addSampleRequestFiles"
      text={t('addFiles')}
      size="small"
      icon={Icons.IconAttach}
      onUpload={addHandler}
      progress={progress}
      multiple
    />
  )
}
